import { debounce } from "@/utils/common-js";
import { decoratorLock, decoratorOnce, type DecoratorLockOptions } from "@/utils/decorator";
import { useCallback, useMemo, useRef } from "react";

export const useDecoratorDebounce = (fn: Function, opts: { waitTime: number}) => {
  const fnRef = useRef(fn);

  // 更新 ref
  fnRef.current = fn;

  const wrapperFn = useCallback((...args: any[]) => {
    return fnRef.current(...args);
  }, []); // 空依赖数组保持引用稳定

  return useMemo(() => debounce(wrapperFn, opts.waitTime), []);
}


export const useDecoratorLock = (fn: Function, options?: DecoratorLockOptions) => {
  // 使用 ref 存储最新的函数
  const fnRef = useRef(fn);
  
  // 更新 ref
  fnRef.current = fn;
  
  // 创建一个稳定的包装函数，它总是调用最新的函数
  const wrapperFn = useCallback((...args: any[]) => {
    return fnRef.current(...args);
  }, []); // 空依赖数组保持引用稳定

  return useMemo(() => decoratorLock(wrapperFn, options), []);
}

export const useDecoratorOnce = (fn: Function) => {
  const fnRef = useRef(fn);
  
  // 更新 ref
  fnRef.current = fn;

  const wrapperFn = useCallback((...args: any[]) => {
    return fnRef.current(...args);
  }, []); // 空依赖数组保持引用稳定

  return useMemo(() => decoratorOnce(wrapperFn), []);
}
